/**
 * Messages still awaiting the homeowner's answer.
 *
 * The server re-validates each prompt against the live visit / preference / proposal
 * rows, so an answered prompt disappears on the next fetch without the client filtering
 * anything — the replacement for V4's `messagesPromptAction`, which returned raw
 * messages and made the client parse an `extends` JSON blob into eight booleans of
 * which two were ever read.
 */

import {
  type ChannelPromptBlock,
  useGetChannelsPromptBlocksByCid,
} from "./channel-endpoints";

export function useChannelPromptBlocks(cid: string, enabled = true) {
  return useGetChannelsPromptBlocksByCid({ cid }).get({
    enabled: enabled && !!cid,
  });
}

export type { ChannelPromptBlock };
